import { fetchAccounts, fetchSavingsData } from '../../services/API';
import { handleNetworkError } from '../../utils';

export const getSavingsData = async ({ commit }, payload) => {
  commit('FETCHING_SAVINGS_DATA', true);
  commit('SET_SAVINGS_DATA', []);
  try {
    let {data, pagination} = await fetchSavingsData(payload);
    data = data.map(({ displayName, amount }) => {
      return {
        user: displayName,
        amount
      }
    });
    commit('FETCHING_SAVINGS_DATA', false);
    commit('SET_SAVINGS_DATA', {data, pagination});
  } catch (error) {
    handleNetworkError(error, "Error fetching savings data:");
    commit('FETCHING_SAVINGS_DATA', false);
    commit('SET_SAVINGS_DATA', null);
  }
}

export const getSummaries = async ({dispatch}) => {
  fetchAccounts('main').then(async ({count, totalAmount}) => {
    const savingAccounts = await fetchAccounts('savings');
    count += savingAccounts.count;
    totalAmount += savingAccounts.totalAmount;

    dispatch('setDashboardSummary', {summaryId: 'savings', count, amount: totalAmount});
  })
  .catch(error => handleNetworkError(error, "Error fetching saving accounts:"));

  fetchAccounts('loan').then(({count, totalAmount}) => {
    dispatch('setDashboardSummary', {summaryId: 'loans', count, amount: totalAmount});
  })
  .catch(error => handleNetworkError(error, "Error fetching loan accounts:"));
}

export const setDashboardSummary = async ({state, commit}, { summaryId, count, amount }) => {
  try {
    let summaries = state.dashboardSummaries;
    const summaryIndex = summaries.findIndex(({id}) => id === summaryId);
    let summary = summaries[summaryIndex];
    summary = { ...summary, count, amount, visible: true };
    commit('SET_DASHBOARD_SUMMARIES', {index: summaryIndex, value: summary});
  } catch (error) {
    handleNetworkError(error, "Error fetching users:");
  }
}
